// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Restaurants/';
export const RestaurantActionTypes = {
  CATEGORY: ActionHelper.createActionTypes(actionTypePrefix, 'CATEGORY'),
  GALLERY: ActionHelper.createActionTypes(actionTypePrefix, 'GALLERY'),
  ALL_RESTAURANTS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'ALL_RESTAURANTS'
  ),
  BANNER: ActionHelper.createActionTypes(actionTypePrefix, 'BANNER'),
  BEER: ActionHelper.createActionTypes(actionTypePrefix, 'BEER'),
  TOGGLE_MENU_MODAL: {
    TOGGLE_MODAL: `${actionTypePrefix}/TOGGLE_MODAL`,
  },
};
